import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import LivePagesByLineLastUpdatedQuery, {
	type LivePagesByLineLastUpdatedQuery$data,
	type LivePagesByLineLastUpdatedQuery$variables,
} from './by-line/__generated__/LivePagesByLineLastUpdatedQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadLastUpdated(
	contentId: any,
	useCache: any,
): Promise<{
	data: LivePagesByLineLastUpdatedQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<LivePagesByLineLastUpdatedQuery$data, LivePagesByLineLastUpdatedQuery$variables>({
		query: LivePagesByLineLastUpdatedQuery,
		variables: {
			contentId,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
